export const IN_APP = 'IN_APP';
export const EMAIL = 'EMAIL';
export const SLACK = 'SLACK';

export const notificationChannels = {
    IN_APP,
    EMAIL,
    SLACK,
};
